import React, { useEffect, useState } from 'react';
import SignalLoader from './SignalLoader';
import './styles/OfflineScreen.css';

const OfflineScreen = ({ open, onRetry }) => {
  const [checking, setChecking] = useState(false);

  useEffect(() => {
    if (!open) setChecking(false);
  }, [open]);

  if (!open) return null;

  const handleRetry = async () => {
    if (checking) return;
    setChecking(true);
    try {
      if (typeof onRetry === 'function') {
        await onRetry();
      }
    } finally {
      setChecking(false);
    }
  };

  return (
    <div className="offline-screen" role="alertdialog" aria-modal="true" aria-labelledby="offline-title">
      <div className="offline-screen__card">
        <SignalLoader size="md" />

        <h2 id="offline-title">Нет интернета</h2>
        <p>
          Проверьте соединение с сетью. Как только связь появится,
          приложение продолжит работу само.
        </p>

        <button
          type="button"
          className="offline-screen__retry"
          onClick={handleRetry}
          disabled={checking}
        >
          <i className={`bi ${checking ? 'bi-arrow-repeat spin' : 'bi-wifi'}`} aria-hidden="true" />
          {checking ? 'Проверяем…' : 'Повторить'}
        </button>
      </div>
    </div>
  );
};

export default OfflineScreen;
